const handleDeletePlaceModalPlaces = {
  confirmTrue: 'Você não pode deletar esse lugar, pois tem ',
  true: 'equipamentos',
  false: 'filhos',
  text: 'delete eles antes.',
  titleTrue: 'DELETAR LUGAR',
  confirmFalse: 'Deseja realmente deletar esse lugar?',
  titleFalse: 'DELETAR LUGAR',
};

export default handleDeletePlaceModalPlaces;
